<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M14.5 13C14.5 13.1326 14.4473 13.2598 14.3536 13.3536C14.2598 13.4473 14.1326 13.5 14 13.5H2C1.86739 13.5 1.74021 13.4473 1.64645 13.3536C1.55268 13.2598 1.5 13.1326 1.5 13C1.5 12.8674 1.55268 12.7402 1.64645 12.6464C1.74021 12.5527 1.86739 12.5 2 12.5H2.5V8.5C2.5 8.36739 2.55268 8.24021 2.64645 8.14645C2.74021 8.05268 2.86739 8 3 8H4.5C4.63261 8 4.75979 8.05268 4.85355 8.14645C4.94732 8.24021 5 8.36739 5 8.5V12.5H6V5.5C6 5.36739 6.05268 5.24021 6.14645 5.14645C6.24021 5.05268 6.36739 5 6.5 5H8.5C8.63261 5 8.75979 5.05268 8.85355 5.14645C8.94732 5.24021 9 5.36739 9 5.5V12.5H10V2.5C10 2.36739 10.0527 2.24021 10.1464 2.14645C10.2402 2.05268 10.3674 2 10.5 2H13C13.1326 2 13.2598 2.05268 13.3536 2.14645C13.4473 2.24021 13.5 2.36739 13.5 2.5V12.5H14C14.1326 12.5 14.2598 12.5527 14.3536 12.6464C14.4473 12.7402 14.5 12.8674 14.5 13Z"
      fill="#3B4143"
    />
  </svg>
</template>
